import pptxgen from 'pptxgenjs'
import { parse } from 'svg-parser'
import renderSvgElement from './render-svg'

function exportPresentation(svgs, name) {
  let presentation = new pptxgen()

  const originNode = {
    x: 0,
    y: 0,
    yAcc: 0,
    xAcc: 0,
    height: 1920,
    width: 1080,
  }

  for (const svg of svgs) {
    const slide = presentation.addSlide()
    const parsedSvg = parse(svg)

    renderSvgElement(originNode, slide, parsedSvg)
  }

  return presentation.writeFile({ fileName: `${name}.pptx` })
}

export default exportPresentation
